import { SliicerCosmosDoc } from './cosmos-document';

export interface StormDefinition extends SliicerCosmosDoc {
    minRainfallThreshold: string;
    minimumTimeBetweenEventsMinutes: number;
}

export interface DryDayDefinition extends SliicerCosmosDoc {
    dailyMaximum: DailyMaximum[];
    maxFlowPercentage: number;
    minFlowPercentage: number;
}

export interface DepthDurationFrequency extends SliicerCosmosDoc {
    ddfTable: DdfTable[];
}

export enum BaseInfiltrationCalculationOption 
{
    Net = 'Net',
    Gross = 'Gross'
}

export enum BaseInfiltrationMethod {
    PercentMinimum = 'PercentMinimum',
    Mitchell = 'Mitchell',
    StevensSchutzbach = 'StevensSchutzbach',
    WastewaterProduction = 'WastewaterProduction'
}

export interface WasteWaterBaseInfiltration extends SliicerCosmosDoc {
    infiltrationType: BaseInfiltrationCalculationOption;
    method: BaseInfiltrationMethod;
    constant: number;
}

export interface DailyMaximum {
    accumulation: number;
    dayCount: number;
}

export interface UIDdfTable {
    month1?: string;
    month2?: string;
    month3?: string;
    month4?: string;
    month6?: string;
    month9?: string;
    year1?: string;
    year2?: string;
    year5?: string;
    year10?: string;
    year25?: string;
    year50?: string;
    year100?: string;
    year200?: string;
    year500?: string;
    year1000?: string;
    duration?: string;
    durationvalue: string;
    durationMinutes: string;

    checked?: boolean;
}

export interface DdfTable {
    month1: number;
    month2: number;
    month3: number;
    month4: number;
    month6: number;
    month9: number;
    year1: number;
    year2: number;
    year5: number;
    year10: number;
    year25: number;
    year50: number;
    year100: number;
    year200: number;
    year500: number;
    year1000: number;
    duration: string;
    durationvalue: number;
    durationMinutes: number;
    checked?: boolean;
}

export const uItoAPIDDfTable = (table: UIDdfTable): DdfTable => {
    return {
        month1: parseFloat(table.month1),
        month2: parseFloat(table.month2),
        month3: parseFloat(table.month3),
        month4: parseFloat(table.month4),
        month6: parseFloat(table.month6),
        month9: parseFloat(table.month9),
        year1: parseFloat(table.year1),
        year2: parseFloat(table.year2),
        year5: parseFloat(table.year5),
        year10: parseFloat(table.year10),
        year25: parseFloat(table.year25),
        year50: parseFloat(table.year50),
        year100: parseFloat(table.year100),
        year200: parseFloat(table.year200),
        year500: parseFloat(table.year500),
        year1000: parseFloat(table.year1000),
        duration: table.duration,
        durationvalue: parseFloat(table.durationvalue),
        durationMinutes: parseFloat(table.durationMinutes)
    }
}

export class DryDefinitionDetails {
    public minRainfallPrevOneDay: number;
    public minRainfallPrevThreeDays: number;
    public minRainfallPrevFiveDays: number;
    public maximumFlowPercentage: number;
    public minimumFlowPercentage: number;

    public minRainPrevOneDay : string;
    public minRainPrevThreeDays : string;
    public minRainPrevFiveDays : string;
    public id?: string;
}
